var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Airdrop 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.5,
    d: "M29.9797 3.71289C33.2069 3.71289 36.2766 4.58773 38.9411 6.12248C41.0635 7.33663 42.9161 8.96826 44.3875 10.9055C46.1709 13.2414 47.4057 16.0241 47.8763 19.0662C48.1097 20.6817 47.6113 22.3386 46.5508 23.5696H46.5475C46.2456 23.9219 45.9005 24.239 45.519 24.5115L37.3215 31.6009C36.9045 31.5335 36.471 31.4992 36.023 31.4992L32.1037 31.4917C32.1329 31.4625 32.1632 31.4343 32.1949 31.407L41.2576 23.5696H31.718V31.491L28.218 31.4842V23.5696H18.6689L27.7247 31.4401C27.7411 31.4541 27.7569 31.4686 27.7728 31.4833L23.9597 31.4758C23.4785 31.4758 23.0145 31.5174 22.5704 31.5974L14.4157 24.5101C14.035 24.2381 13.6905 23.9214 13.389 23.5696C13.2501 23.4082 13.1187 23.2378 12.9989 23.0597C12.2352 21.9377 11.8692 20.5504 12.0735 19.1346L12.083 19.0662C12.1291 18.7678 12.1826 18.4718 12.2433 18.1786C13.9613 9.87345 21.4154 3.71289 29.9797 3.71289Z",
    fill: "url(#paint0_linear_5365_40543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0681 41.4884L17.0772 38.5932C17.1005 34.3932 19.9239 31.4766 23.9606 31.4766L36.0239 31.4999C37.9839 31.4999 39.6639 32.1532 40.9006 33.3899C42.1839 34.6732 42.8839 36.5399 42.8839 38.6632L42.8722 42.3863L42.8839 46.1091C42.8839 48.2325 42.1839 50.0991 40.9006 51.3825C39.6639 52.6191 37.9839 53.2725 36.0239 53.2725L23.9606 53.2958C19.9239 53.2958 17.1005 50.3791 17.0772 46.1791L17.0681 43.2839H17.0625L17.0653 42.3863L17.0625 41.4884H17.0681Z",
    fill: "#6AD67D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.2734 41.4883H32.6634C33.6201 41.4883 34.4134 40.7183 34.4134 39.7383C34.4134 38.7816 33.6201 37.9883 32.6634 37.9883H27.2734C26.3168 37.9883 25.5234 38.7816 25.5234 39.7383C25.5234 40.7183 26.3168 41.4883 27.2734 41.4883Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5365_40543",
    x1: 45.0687,
    y1: 5.78557,
    x2: 11.0555,
    y2: 40.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AD67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AD67D",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPi);
export default __webpack_public_path__ + "static/media/pi.3922a0d8808fe779ecabfca2af7f78c0.svg";
export { ForwardRef as ReactComponent };